import { Ptag } from "components/core";
import React from "react";

function BenefitSetupDetailSection({ title, children }) {
  return (
    <section >
      <Ptag fontSize="16px" marginBottom="12px">
        {title}
      </Ptag>
      <div style={{marginBottom:"24px"}}> {children}</div>
    </section>
  );
}

export default BenefitSetupDetailSection;
